import React, { useState } from 'react';
import { Button, Table } from 'semantic-ui-react';
import dateToYYYYMMDD from '../../../../../util/dateToYYYY-MM-DD';
import { deleteDemoDevice, updateDemoDevice } from '../../../apis/demo.api';
import DemoDeviceFormModal from './DemoDeviceFormModal';

const DeviceTable = ({ demoDevices = [] }) => {
  const [selectedDeviceId, setSelectedDeviceId] = useState(null);
  const [initialValues, setInitialValues] = useState({});

  const open = selectedDeviceId !== null;

  const handleDelete = async ({ id }) => {
    const confirmed = window.confirm('정말로 삭제하시겠습니까?');
    if (!confirmed) return;
    try {
      await deleteDemoDevice(id);
      window.location.reload();
    } catch (error) {
      console.error(error);
      alert('데모기기 삭제에 실패했습니다.');
    }
  };

  const handleUpdate = (device) => {
    setInitialValues({
      macAddress: device.macAddress,
      model: device.model,
      memo: device.memo,
    });
    setSelectedDeviceId(device.id);
  };

  const handleSubmit = async (data) => {
    await updateDemoDevice(selectedDeviceId, data);
    setSelectedDeviceId(null);
    window.location.reload();
  };

  return (
    <>
      <Table>
        <Table.Header>
          <Table.Row textAlign="center">
            <Table.HeaderCell>MAC Address</Table.HeaderCell>
            <Table.HeaderCell>Model</Table.HeaderCell>
            <Table.HeaderCell>Memo</Table.HeaderCell>
            <Table.HeaderCell>Created At</Table.HeaderCell>
            <Table.HeaderCell>Created By</Table.HeaderCell>
            <Table.HeaderCell>Updated At</Table.HeaderCell>
            <Table.HeaderCell>Updated By</Table.HeaderCell>
            <Table.HeaderCell>Actions</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {demoDevices.length === 0 && (
            <Table.Row>
              <Table.Cell colSpan="7" textAlign="center">
                No demo devices found
              </Table.Cell>
            </Table.Row>
          )}
          {demoDevices.map((device) => (
            <Table.Row key={device.id} textAlign="center">
              <Table.Cell>{device.macAddress}</Table.Cell>
              <Table.Cell>{device.model}</Table.Cell>
              <Table.Cell>{device.memo}</Table.Cell>
              <Table.Cell>
                {dateToYYYYMMDD(new Date(device.createInfo.at))}
              </Table.Cell>
              <Table.Cell>{device.createInfo.name}</Table.Cell>
              <Table.Cell>
                {device.updateInfo?.at
                  ? dateToYYYYMMDD(new Date(device.updateInfo.at))
                  : '-'}
              </Table.Cell>
              <Table.Cell>
                {device.updateInfo?.name ? device.updateInfo.name : '-'}
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: 'flex',
                    gap: '4px',
                    justifyContent: 'center',
                  }}
                >
                  <Button icon="pencil" onClick={() => handleUpdate(device)} />
                  <Button icon="trash" onClick={() => handleDelete(device)} />
                </div>
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
      {open && (
        <DemoDeviceFormModal
          open={open}
          onClose={() => setSelectedDeviceId(null)}
          onSubmit={handleSubmit}
          initialValues={initialValues}
        />
      )}
    </>
  );
};

export default DeviceTable;
